import {
    Component,
    Input,
    OnInit,
    ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';

import {ChatPanelComponent} from '../chat-panel/chat-panel.component';

@Component({
    selector: 'fuse-chat-panel-dynamic',
    templateUrl: './chat-panel-dynamic.component.html',
    styleUrls: ['./chat-panel-dynamic.component.scss']
})

export class FuseChatPanelComponentDynamic implements OnInit {
    @Input() public RefChatPanelComponent: any;

    constructor(private viewRef: ViewContainerRef, private componentResolver: ComponentFactoryResolver) {

    }

    ngOnInit() {

        if (this.RefChatPanelComponent) {
            this.viewRef.createComponent(this.RefChatPanelComponent);
        } else {
            const defaultChatPanelComponent = this.componentResolver.resolveComponentFactory(ChatPanelComponent);
            this.viewRef.clear();
            this.viewRef.createComponent(defaultChatPanelComponent);
        }


    }

}
